module.exports = angular.module('cartographer.common.location', [])

$            = require 'jquery'
_            = require 'underscore'
LatLon       = require 'geodesy-libraries/latlon'
LatLonE      = require 'geodesy-libraries/latlon-ellipsoid'
OsGridRef    = require 'geodesy-libraries/osgridref'
turfCenter   = require '@turf/center'
turfDistance = require '@turf/distance'
turfMidpoint = require '@turf/midpoint'
turfHelpers  = require '@turf/helpers'

module.exports.factory 'crtLocation', $DI (crtLog, $q, $window, $rootScope, crtConfig) ->
  # feature -> geometry
  _unwrap = (feat) ->
    feat.geometry

  # geometry -> feature
  _wrap = (geometry) ->
    ({ type: "Feature", geometry })

  # number number -> location
  createPoint = (longitude, latitude) ->
    # crtLog.debug('crtLocation.createPoint', longitude, latitude)
    _unwrap(turfHelpers.point([ longitude, latitude ]))

  _isGeometryOfType = (geom, types) ->
    geom? &&
    geom.type? &&
    geom.coordinates? &&
    types.indexOf(geom.type) >= 0 &&
    _.isArray(geom.coordinates)

  isGeometry = (geom) ->
    # crtLog.debug('crtLocation.isGeometry', geom)
    _isGeometryOfType(geom, [
      "Point"
      "MultiPoint"
      "LineString"
      "MultiLineString"
      "Polygon"
      "MultiPolygon"
      "GeometryCollection"
    ])

  isPoint = (geom) ->
    # crtLog.debug('crtLocation.isPoint', geom)
    _isGeometryOfType(geom, [ "Point" ])

  # geometry -> geometry
  center = (geom) ->
    # crtLog.debug('crtLocation.center', geom)
    switch geom.type
      when 'Point' then geom
      else _unwrap(turfCenter(_wrap(geom)))

  # geometry -> number
  distance = (geom1, geom2) ->
    a = turfCenter(_wrap(geom1))
    b = turfCenter(_wrap(geom2))
    # crtLog.debug('crtLocation.distance', { geom1, geom2, a, b, dist: turfDistance(a, b) })
    turfDistance(a, b) * 1000

  midpoint = (geom1, geom2) ->
    # crtLog.debug('crtLocation.midpoint', geom1, geom2)
    a = turfCenter(_wrap(geom1))
    b = turfCenter(_wrap(geom2))
    _unwrap(turfMidpoint(a, b))

  # geometry -> number
  lng = (geom) ->
    center(geom).coordinates[0]

  # geometry -> number
  lat = (geom) ->
    center(geom).coordinates[1]

  # Location of Big Ben.
  #
  # -> location
  bigBen = ->
    createPoint(-0.1246717, 51.500676399999995)

  # Center the word "London" on the map.
  #
  # -> location
  london = ->
    createPoint(-0.12, 51.505)

  # -> promiseOf(location)
  findMe = ->
    # crtLog.debug('crtLocation.findMe')

    deferred = $q.defer()

    onSuccess = (position) ->
      $rootScope.$apply ->
        # crtLog.debug('crtLocation.findMe onSuccess', position)
        deferred.resolve(createPoint(position.coords.longitude, position.coords.latitude))
        return
      return

    onError = ->
      $rootScope.$apply ->
        # crtLog.debug('crtLocation.findMe onError')
        deferred.resolve(london())
        return
      return

    if navigator.geolocation
      navigator.geolocation.getCurrentPosition(onSuccess, onError)
    else
      onError()

    return deferred.promise

  # string -> or(geometry null)
  parseNgr = (str) ->
    # crtLog.debug('crtLocation.parseNgr', str)
    grid = OsGridRef.parse(str)
    osgb = grid && OsGridRef.osGridToLatLon(grid)
    wgs  = osgb.convertDatum(LatLonE.datum.WGS84)
    if wgs && !_.isNaN(wgs.lat) && !_.isNaN(wgs.lon)
      createPoint(wgs.lon, wgs.lat)
    else
      null

  # string -> or(geometry null)
  parseLatLng = (str) ->
    # crtLog.debug('crtLocation.parseLatLng', str)
    [ latString, lonString ] = str.split(',')
    if latString && lonString
      lat = parseFloat($.trim(latString))
      lon = parseFloat($.trim(lonString))
      if _.isNaN(lat) || _.isNaN(lon) then undefined else createPoint(lon, lat)
    else
      null

  # string -> or(geometry null)
  parseLngLat = (str) ->
    # crtLog.debug('crtLocation.parseLngLat', str)
    [ lonString, latString ] = str.split(',')
    if lonString && latString
      lon = parseFloat($.trim(lonString))
      lat = parseFloat($.trim(latString))
      if _.isNaN(lat) || _.isNaN(lon) then undefined else createPoint(lon, lat)
    else
      null

  # geometry [integer] -> or(string null)
  formatNgr = (geom, precision = crtConfig.location.ngrPrecision) =>
    # crtLog.debug('crtLocation.formatNgr', geom, precision)
    loc  = center(geom)
    wgs  = new LatLonE(loc.coordinates[1], loc.coordinates[0], LatLonE.datum.WGS84)
    osgb = wgs.convertDatum(LatLonE.datum.OSGB36)

    ngr = OsGridRef.latLonToOsGrid(osgb)?.toString(precision)
    if ngr == "??" || ngr == ""
      null
    else
      ngr

  # geometry -> string
  formatLatLng = (geom) ->
    # crtLog.debug('crtLocation.formatLatLng', geom)
    loc = center(geom)
    "#{loc.coordinates[1].toFixed(6)},#{loc.coordinates[0].toFixed(6)}"

  # geometry -> string
  formatLngLat = (geom) ->
    # crtLog.debug('crtLocation.formatLngLat', geom)
    loc = center(geom)
    "#{loc.coordinates[0].toFixed(6)},#{loc.coordinates[1].toFixed(6)}"

  # geometry -> string
  formatQueryParameter = (geom) ->
    formatLatLng(geom)

  # geometry -> { lng: number, lat: number }
  toLngLatObject = (geom) ->
    loc = center(geom)
    return {
      lng: loc.coordinates[0]
      lat: loc.coordinates[1]
    }

  # geometry -> { lng: number, lat: number }
  fromLngLatObject = (obj) ->
    createPoint(obj.lng, obj.lat)

  return {
    createPoint

    isGeometry
    isPoint

    center
    distance
    midpoint
    lng
    lat

    bigBen
    london
    findMe

    parseNgr
    parseLatLng
    parseLngLat
    formatNgr
    formatLatLng
    formatLngLat
    formatQueryParameter

    toLngLatObject
    fromLngLatObject
  }

module.exports.filter 'ngr', $DI (crtLocation) ->
  (geom, digits = 10) ->
    if crtLocation.isGeometry(geom) then crtLocation.formatNgr(geom, digits) else ""
